module.exports = __webpack_public_path__ + "static/media/storepreviewStoreSeven.ba82f110.svg";